<template>
  <div>
    <div class="common-form">添加渠道用户</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="渠道名称" :rules="[{ required: true, message: '渠道名称' }]" prop="channelName">
        <el-input class="max-w460" v-model="form.channelName"></el-input>
      </el-form-item>
      <el-form-item label="渠道类型" v-if="sence=='add'">
      <el-radio-group v-model="form.type">
        <el-radio :label="1">渠道</el-radio>
        <el-radio :label="2">业务员</el-radio>
      </el-radio-group>
    </el-form-item>
    
      <el-form-item label="账号" :rules="[{ required: true, message: '账号不能为空' }]" prop="username">
        <el-input class="max-w460" v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" :rules="[{ required: true, message: '密码不能为空' }, { max: 16, min: 6, message: '密码为6-16位' }]"
        prop="password">
        <el-input class="max-w460" type="password" v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item label="昵称" :rules="[{ required: true, message: '请输入昵称' }]" prop="nickname">
        <el-input class="max-w460" v-model="form.nickname"></el-input>
      </el-form-item>

      <el-form-item label="头像：" :rules="[{ required: true, message: '请上传头像图片' }]" prop="avatarUrl">
        <el-row>
          <div class="draggable-list">
            <div class="item img-select" v-if="imageId == 0" @click="openProductUpload('image', 'image')">
              <i class="el-icon-plus"></i>
            </div>
            <div v-if="imageId != 0" class="item" @click="openProductUpload('image', 'image')">
              <img :src="form.avatarUrl" width="100" height="100" />
            </div>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="手机号" :rules="[{ required: true, message: '手机号不能为空' }]" prop="mobile">
        <el-input class="max-w460" v-model="form.mobile"></el-input>
      </el-form-item>

      <el-form-item label="余额">
        <el-input class="max-w460" v-model="form.balance"></el-input>
      </el-form-item>
      <!-- <el-form-item label="类型" :rules="[{ required: true, message: '请输入类型' }]" prop="type">
        <el-select class="max-w460" style="width:100%" v-model="form.type" placeholder="请输入类型">
          <el-option :value="1" label="代理"></el-option>
          <el-option :value="2" label="渠道"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="代理等级" v-if="form.type == 1" :rules="[{ required: true, message: '请选择代理等级' }]"
        prop="agent_type">
        <el-select class="max-w460" style="width:100%" v-model="form.agent_type" placeholder="请选择代理等级">
          <el-option :value="1" label="一级分销"></el-option>
          <el-option :value="2" label="二级分销"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="上级代理" v-if="form.agent_type == 2 || form.type == 2"
        :rules="[{ required: true, message: '请选择上级代理' }]" prop="user_id">
        <el-select class="max-w460" style="width:100%" v-model="form.user_id" placeholder="请选择">
          <el-option v-for="(item, index) in agentlist" :key="index" :value="item.id" :label="item.username"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分成比例" :rules="[{ required: true, message: '分成比例不能为空' }]" prop="scale">
        <el-input class="max-w460" v-model="form.scale"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即添加</el-button>

      </el-form-item>
    </el-form>
    <!--图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</template>

<script>
import ChannelApi from "@/api/channel.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        channelName:'',
        username: "",
        password: "",
        nickname: null,
        mobile: null,
        balance: "0.00",
        avatarUrl: "",
        scale: '',
        type:1
      },
      agentlist: [],
      imageId: "",
      filePath: "",
      isProductUpload: false,
      file_name: "image",
      sence:'add'
    };
  },
  created() {
    console.log(this.$route.query)
    this.form.pid = this.$route.query.id;
    this.sence = this.$route.query.sence;
    if( this.sence=='addxiaji'){
      this.form.type=2

    }
    // this.getChanneloneAgent();
  },

  methods: {
    // 查询技师详情
    getChanneloneAgent: function () {
      let self = this;
      ChannelApi.ChanneloneAgent(
        {
          id: self.id
        },
        true
      )
        .then(res => {
          self.agentlist = res.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开上传图片*/
    openProductUpload: function (fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else if (fileType == "audio") {
        this.config = {
          total: 1,
          fileType: "audio"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },
    /*上传活动图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "image") {
          this.imageId = e[0].fileId;
          this.form.avatarUrl = e[0].filePath;

          // this.filePath = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    },

    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          ChannelApi.ChanneluserAdd(self.form, true)
            .then(data => {
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.from = {
                username: "",
                password: "",
                nickname: null,
                mobile: null,
                type: 1,
                agent_type: null,
                balance: "0.00",
                avatarUrl: "",
                agent_code: "", //代理邀请码
                channel_code: "" //渠道邀请码
              };
              self.$router.push("/channel/channel/index");
              // Technician
            })
            .catch(error => { });
        }
      });
    }
  }
};
</script>




<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper>span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/channel/channel/add.vue